import Vue from 'vue';
import * as news from "../../../static/json/news.json";
//模块：新闻资讯
export default Vue.extend({
    name: "n-weather",
    data: function () {
        return {
            crtMenu: 'n1',
        };
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：切换菜单
         * @param val
         */
        setMenu: function (val) {
            this.crtMenu = val;
        },
    },
    computed: {
        menuList: function () {
            return this.$t('newsmenu');
        },
        newsList: function () {
            var temp = news['news'];
            var url = "../../../static/img/news/";
            for (var _i = 0, _a = temp['n1']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = item.img == "" ? "" : url + item.img;
            }
            return temp;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/news/n-weather.vue
// module id = null
// module chunks = 